<template>
  <div>
    <div class="col-lg-12">
      <div><strong>Description:</strong></div>
        <div class="m-t-sm well">
          <a-edit-txt
            type="textarea"
            :text="project.description"
            @input="updateProperty($event, 'description')"
            close-on-save="true"
          ></a-edit-txt>
        </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  data () {
    return {
      project: {}
    }
  },
  mounted () {
    this.getProject()
  },
  methods: {
    async getProject () {
      let r = await axios.get('/v2/projects/' + this.$route.params.id)
      this.project = r.data
    },
    async updateProperty (val, key) {
      let data = {}
      data[key] = val
      try {
        await axios.patch(`/v2/projects/${this.project.id}`, data)
        this.$toastr.success(`Task property ${key} updated`, 'Success')
      } catch (error) {
        this.$toastr.error('Failed to update Task', error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Projects/Single/Content/Tabs/ProjectData.vue